module.exports = __webpack_public_path__ + "static/media/card-image-3.e50f8799.jpg";